module.exports = {
      id: "ic-cat-averages-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-cat-averages-usage",
      toString: function () {
        return this.url;
      }
    }